import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      news: { title: "", createTime: "", content: "" }
    };
  },
  created: function() {
    this.loadNews();
  },
  methods: {
    async loadNews() {
      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest(
        "/app/news/news/" + this.$route.query.newsId,
        "get",
        null
      );
      loadingInstance.close();
      if (res !== null && res !== undefined && res.code === 200) {
        this.news = res.data;
      }
    }
  }
};
